// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-cg8_","colBig":"styles_colBig__3qZDw","colSmall":"styles_colSmall__3DD-s"};